export var StatusbarStyle;
(function (StatusbarStyle) {
    StatusbarStyle["Light"] = "light";
    StatusbarStyle["Dark"] = "dark";
})(StatusbarStyle || (StatusbarStyle = {}));
//# sourceMappingURL=definitions.js.map